document.addEventListener("DOMContentLoaded", function () {
  const MQ = window.matchMedia("(min-width: 1024px)");
  const isDesktop = () => MQ.matches;

  const FABRICS_SELECTOR = ".navmenu-item--fabrics";
  const ACCESS_SELECTOR = ".navmenu-item--accessories";
  const TARGET_SELECTOR = `${FABRICS_SELECTOR}, ${ACCESS_SELECTOR}`;

  function getDetails(navItem) {
    return navItem ? navItem.querySelector("details") : null;
  }

  function getSummary(navItem) {
    return navItem ? navItem.querySelector("summary") : null;
  }

  function openViaDetails(navItem) {
    const details = getDetails(navItem);
    const summary = getSummary(navItem);
    if (details) details.setAttribute("open", "open");
    if (summary) summary.setAttribute("aria-expanded", "true");
  }

  function closeViaDetails(navItem) {
    const details = getDetails(navItem);
    const summary = getSummary(navItem);
    if (details) details.removeAttribute("open");
    if (summary) summary.setAttribute("aria-expanded", "false");
  }

  function openMenuFor(navItem) {
    if (!isDesktop() || !navItem) return;
    navItem.classList.add("is-open");
    // Also open <details> if theme uses it
    openViaDetails(navItem);
  }

  function closeMenuFor(navItem, relatedTarget) {
    if (!isDesktop() || !navItem) return;

    const mega = navItem.querySelector(".mega-menu");
    if (
      relatedTarget &&
      (navItem.contains(relatedTarget) || (mega && mega.contains(relatedTarget)))
    ) {
      return;
    }

    navItem.classList.remove("is-open");
    closeViaDetails(navItem);
  }

  /**
   * BOOTSTRAP FIX:
   * Many themes only bind/initialize mega menu behavior after the first click.
   * We "warm up" Fabrics/Accessories once on desktop by programmatically toggling details open/close,
   * while preventing navigation/toggle side effects.
   */
  function bootstrapThemeMenus() {
    if (!isDesktop()) return;

    document.querySelectorAll(TARGET_SELECTOR).forEach((navItem) => {
      const details = getDetails(navItem);
      const summary = getSummary(navItem);

      if (!details || !summary) return;

      // Prevent the theme's summary click handlers from navigating during bootstrap
      const blocker = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      summary.addEventListener("click", blocker, { capture: true, once: true });

      // Toggle open then close quickly to force theme init
      try {
        details.setAttribute("open", "open");
        summary.setAttribute("aria-expanded", "true");
      } catch (e) {}

      // Close on next frame to keep UI unchanged
      requestAnimationFrame(() => {
        try {
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        } catch (e) {}
      });
    });
  }

  // -------------------------
  // HOVER EVENTS (DELEGATION)
  // -------------------------
  document.addEventListener("mouseover", function (e) {
    if (!isDesktop()) return;
    const navItem = e.target.closest(TARGET_SELECTOR);
    if (navItem) openMenuFor(navItem);
  });

  document.addEventListener("mouseout", function (e) {
    if (!isDesktop()) return;
    const navItem = e.target.closest(TARGET_SELECTOR);
    if (navItem) closeMenuFor(navItem, e.relatedTarget);
  });

  // -----------------------------------------
  // ACCESSORIES SIDEBAR: SWITCH PANEL ON HOVER
  // -----------------------------------------
  document.addEventListener("mouseover", function (e) {
    if (!isDesktop()) return;

    const btn = e.target.closest(".mega-menu__sidebar-item");
    if (!btn) return;

    const menuRoot = btn.closest(".mega-menu--accessories");
    if (!menuRoot) return;

    const sidebarItems = menuRoot.querySelectorAll(".mega-menu__sidebar-item");
    const panels = menuRoot.querySelectorAll(".mega-menu__panel");
    const handle = btn.dataset.accHandle;

    sidebarItems.forEach((b) => b.classList.toggle("is-active", b === btn));
    panels.forEach((panel) =>
      panel.classList.toggle("is-active", panel.dataset.accPanel === handle)
    );
  });

  // Shopify header can be re-rendered
  document.addEventListener("shopify:section:load", function () {
    bootstrapThemeMenus();
  });

  // Resize handling
  window.addEventListener("resize", function () {
    if (!isDesktop()) {
      document.querySelectorAll(TARGET_SELECTOR).forEach((navItem) => {
        navItem.classList.remove("is-open");
        closeViaDetails(navItem);
      });
    } else {
      bootstrapThemeMenus();
    }
  });

  // Init
  bootstrapThemeMenus();
});

(function () {
  if (!window.location.pathname.includes("/products/")) return;

  function triggerBSSVAT() {
    if (!window.BSS_B2B || !BSS_B2B.cp) return;

    const storeEl = document.getElementById("bss-b2b-store-data");
    if (!storeEl) return;

    let storeData;
    try {
      storeData = JSON.parse(storeEl.textContent);
    } catch (e) {
      return;
    }

    try {
      BSS_B2B.cp.changeProductPrice(storeData, false, false, true);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    // chạy sau khi theme init xong
    setTimeout(triggerBSSVAT, 300);
    setTimeout(triggerBSSVAT, 1200);

    // nếu theme replace pricing DOM → bắt lại
    const pricing = document.querySelector("[data-product-pricing]");
    if (pricing) {
      const observer = new MutationObserver(function () {
        triggerBSSVAT();
      });
      observer.observe(pricing, { childList: true, subtree: true });
    }
  });
})();
